"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emotionTheming = require("emotion-theming");

var _AccentButton = _interopRequireDefault(require("./AccentButton"));

var _BorderInput = _interopRequireDefault(require("../Input/BorderInput"));

var _InputButton = require("./InputButton.style");

var InputButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(InputButton, _Component);

  function InputButton() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, InputButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(InputButton)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      showButton: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onButtonClick", function (e) {
      _this.props.onButtonClick(e);

      _this.setState({
        showButton: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onInputKeyDown", function (e) {
      _this.props.onInputKeyDown(e);

      if (e.keyCode === 13) {
        if (_this.props.blurOnEnter) {
          _this.onInputBlur(e);
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onInputBlur", function (e) {
      _this.props.onInputBlur(e);

      _this.setState({
        showButton: true
      });
    });
    return _this;
  }

  (0, _createClass2.default)(InputButton, [{
    key: "render",
    value: function render() {
      var theme = this.props.theme;
      var disabledClass = (0, _classnames.default)({
        'theme--disabled-opacity': this.props.disabled
      });

      if (this.state.showButton) {
        var _this$props = this.props,
            buttonProps = _this$props.buttonProps,
            Button = _this$props.buttonClass;
        return _react.default.createElement(Button, (0, _extends2.default)({
          className: (0, _InputButton.forBorder)(theme)
        }, buttonProps, {
          onClick: this.onButtonClick
        }));
      }

      var _this$props2 = this.props,
          inputProps = _this$props2.inputProps,
          onInputChange = _this$props2.onInputChange,
          Input = _this$props2.inputClass;
      return _react.default.createElement(Input, (0, _extends2.default)({}, inputProps, {
        autoFocus: true,
        onBlur: this.onInputBlur,
        onChange: onInputChange,
        onKeyDown: this.onInputKeyDown,
        inputClassName: _InputButton.borderedInput,
        className: disabledClass
      }));
    }
  }]);
  return InputButton;
}(_react.Component);

InputButton.propTypes = {
  buttonClass: _propTypes.default.func,
  buttonProps: _propTypes.default.shape(_AccentButton.default.propTypes).isRequired,
  inputClass: _propTypes.default.func,
  inputProps: _propTypes.default.shape(_BorderInput.default.propTypes).isRequired,
  onButtonClick: _propTypes.default.func,
  onInputBlur: _propTypes.default.func,
  onInputChange: _propTypes.default.func,
  onInputKeyDown: _propTypes.default.func,
  blurOnEnter: _propTypes.default.bool
};
InputButton.defaultProps = {
  buttonClass: _AccentButton.default,
  inputClass: _BorderInput.default,
  onButtonClick: function onButtonClick() {},
  onInputBlur: function onInputBlur() {},
  onInputChange: function onInputChange() {},
  onInputKeyDown: function onInputKeyDown() {},
  blurOnEnter: true
};

var _default = (0, _emotionTheming.withTheme)(InputButton);

exports.default = _default;